import React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { catEventApi } from 'services/apis';
import { useParams } from 'react-router';
import { ReplaceCatEventPayloadDto } from 'libs/pinnacle-sdk';
import { EQueryKeys } from 'constants/query-keys';
import CatEventForm from '../cat-event-form';
import dayjs from 'dayjs';

const UpdateCatEventForm: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();

  const { data: catEvent, isLoading: isFetchingCatEvent } = useQuery(
    [EQueryKeys.CAT_EVENT_BY_ID, id],
    () => catEventApi.getCatEventById({ catEventId: id as string }),
    {
      enabled: !!id,
    }
  );

  const updateCatEventMutation = useMutation<
    void,
    Error,
    ReplaceCatEventPayloadDto
  >(
    async (updatedCatEvent) => {
      await catEventApi.replaceCatEvent({
        catEventId: id as string,
        replaceCatEventPayloadDto: updatedCatEvent,
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([EQueryKeys.CAT_EVENT_BY_ID, id]);
        queryClient.invalidateQueries([EQueryKeys.CAT_EVENT_LIST]);
      },
    }
  );

  return (
    <CatEventForm
      mode="update"
      initialData={
        catEvent
          ? {
              ...catEvent,
              fromDate: catEvent.fromDate
                ? dayjs(catEvent.fromDate)
                : undefined,
              toDate: catEvent.toDate ? dayjs(catEvent.toDate) : undefined,
            }
          : undefined
      }
      onSubmit={updateCatEventMutation.mutateAsync}
      isLoading={isFetchingCatEvent || updateCatEventMutation.isLoading}
    />
  );
};

export default UpdateCatEventForm;
